import React from 'react';
import { Container, Typography, Box, Link, Grid } from '@mui/material';
import './main.css'; // Ensure this file contains the necessary styles
import Logo from '../assets/img/logo.jpeg'; // Replace with your actual logo path

function Footer({ darkMode }) {
  return (
    <footer id="footer" className={`footer ${darkMode ? 'dark-background' : 'light-background'}`}>
      <Container maxWidth="lg">
        {/* Logo and Company Name */}
        <Box display="flex" justifyContent="center" alignItems="center" py={3}>
          <img src={Logo} alt="Fincal Business Solutions Logo" width={100} height={100} style={{ marginRight: 16 }} />
          <Typography variant="h5" className={`sitename ${darkMode ? 'dark-text' : 'light-text'}`} align="center">
            Fincal Business Solutions
          </Typography>
        </Box>
        
        {/* Footer Links Section */}
        <Grid container spacing={4} justifyContent="center" py={3}>
          {/* About Us */}
          <Grid item xs={12} md={4}>
            <Typography variant="h5" className={`footer-title ${darkMode ? 'dark-text' : 'light-text'}`}>About Us</Typography>
            <Typography variant="body2" className={`footer-text ${darkMode ? 'dark-text' : 'light-text'}`}>
              Fincal Business Solutions provides a full range of financial services tailored to your business needs. From accounting to tax compliance, we are committed to delivering solutions that enhance business performance.
            </Typography>
          </Grid>
          
        {/* Services */}
      <Grid item xs={12} md={4}>
        <Typography variant="h5" className={`footer-title ${darkMode ? 'dark-text' : 'light-text'}`}>Quick Links</Typography>
        <div className="footer-links">
          <Link href="/about" className={darkMode ? 'dark-text' : 'light-text'}>About Us</Link>
          <Link href="/services" className={darkMode ? 'dark-text' : 'light-text'}>Services</Link>
          <Link href="/contact" className={darkMode ? 'dark-text' : 'light-text'}>Contact Us</Link>
          <Link href="/" className={darkMode ? 'dark-text' : 'light-text'}>Terms & Conditions</Link>
        </div>
      </Grid>


          {/* Contact Information */}
          <Grid item xs={12} md={4}>
            <Typography variant="h5" className={`footer-title ${darkMode ? 'dark-text' : 'light-text'}`}>Contact Us</Typography>
            <Typography variant="body2" className={`footer-text ${darkMode ? 'dark-text' : 'light-text'}`}>
              Email: <Link href="mailto:info@fincalbusiness.co.ke" className={darkMode ? 'dark-text' : 'light-text'}>info@fincalbusiness.co.ke</Link><br />
              Phone: +254 719269649<br />
              Address: Harambee Avenue,Agip House,6th Floor
            </Typography>
          </Grid>
        </Grid>

            {/* Social Media Links */}
        <div className="social-links">
          <Link href="https://www.facebook.com/profile.php?id=61567810401210" className={`social-icon ${darkMode ? 'dark-text' : 'light-text'}`}>
            <i className="bi bi-facebook"></i>
          </Link>
          <Link href="https://wa.me/+254719269649" className={`social-icon ${darkMode ? 'dark-text' : 'light-text'}`}>
            <i className="bi bi-whatsapp"></i>
          </Link>
          <Link href="https://www.linkedin.com/in/fincal-business-solutions-67a656334/" className={`social-icon ${darkMode ? 'dark-text' : 'light-text'}`}>
            <i className="bi bi-linkedin"></i>
          </Link>
        </div>
        {/* Copyright Section */}
        <Box className="copyright" py={3}>
          <Typography variant="body2" align="center" className={darkMode ? 'dark-text' : 'light-text'}>
            <span>&copy; {new Date().getFullYear()}</span> <strong className="px-1 sitename">Fincal Business Solutions</strong> <span>All Rights Reserved.</span>
          </Typography>
        </Box>
      </Container>
    </footer>
  );
}

export default Footer;
